var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorAlertIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4997 19.333C16.5498 19.333 19.833 16.0498 19.833 11.9997C19.833 7.94959 16.5498 4.66634 12.4997 4.66634C8.44958 4.66634 5.16634 7.94959 5.16634 11.9997C5.16634 16.0498 8.44959 19.333 12.4997 19.333ZM21.833 11.9997C21.833 17.1543 17.6543 21.333 12.4997 21.333C7.34502 21.333 3.16634 17.1543 3.16634 11.9997C3.16634 6.84502 7.34501 2.66634 12.4997 2.66634C17.6543 2.66634 21.833 6.84502 21.833 11.9997Z",
    fill: "#C60F13"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4998 15.7051C13.4998 16.2574 13.0521 16.7051 12.4998 16.7051L12.4915 16.7051C11.9392 16.7051 11.4915 16.2574 11.4915 15.7051C11.4915 15.1528 11.9392 14.7051 12.4915 14.7051L12.4998 14.7051C13.0521 14.7051 13.4998 15.1528 13.4998 15.7051ZM12.4998 13.762C11.9476 13.762 11.4998 13.3142 11.4998 12.762L11.4998 8.36654C11.4998 7.81425 11.9476 7.36654 12.4998 7.36654C13.0521 7.36654 13.4998 7.81425 13.4998 8.36654L13.4998 12.762C13.4998 13.3142 13.0521 13.762 12.4998 13.762Z",
    fill: "#C60F13"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorAlertIcon);
export default __webpack_public_path__ + "static/media/ErrorAlertIcon.21b5ff31be7b8a7d00168517fdf6677d.svg";
export { ForwardRef as ReactComponent };